import useFormatNumber, { classicFormat, percentFormat } from '@/hooks/format/useFormatNumber';

import { formatMilliSeconds, formatMilliSecondsWithDecimals } from '@/utils/format/formatTime';

import useFormatDateTime from './useFormatDateTime';
import useFormatDayOfWeek from './useFormatDayOfWeek';

export const KPI_VALUE_CLASSIC = 'classic';
export const KPI_VALUE_PERCENT = 'percent';
export const KPI_VALUE_MEDIA_VIEWER_CLASSIC = 'media_viewer_classic';
export const KPI_VALUE_MEDIA_VIEWER_PERCENT = 'media_viewer_percent';
export const KPI_VALUE_TIME = 'time';
export const KPI_VALUE_TIME_DECIMAL = 'time_decimal';
export const KPI_VALUE_DATE = 'date';
export const KPI_VALUE_DAY_OF_WEEK = 'dayOfWeek';

const useFormatKpiValue = (
    defaultKpiValueType,
    numbersFormat,
    dateFormat = '',
    timeFormat = '24'
) => {
    const { formatNumber } = useFormatNumber(numbersFormat);
    const { formatDateTime } = useFormatDateTime();
    const { formatDayOfWeek } = useFormatDayOfWeek();

    const formatKpiValue = (value, kpiType = defaultKpiValueType) => {
        switch (kpiType) {
            case KPI_VALUE_CLASSIC:
                return formatNumber(value, classicFormat);
            case KPI_VALUE_PERCENT:
                return formatNumber(value, percentFormat);
            case KPI_VALUE_MEDIA_VIEWER_CLASSIC:
                return formatNumber(value, {});
            case KPI_VALUE_MEDIA_VIEWER_PERCENT:
                return formatNumber(value, {
                    ...percentFormat,
                    maximumFractionDigits: 2
                });
            case KPI_VALUE_TIME:
                return formatMilliSeconds(value);
            case KPI_VALUE_TIME_DECIMAL:
                return formatMilliSecondsWithDecimals(value);
            case KPI_VALUE_DATE:
                return formatDateTime(value, dateFormat);
            case KPI_VALUE_DAY_OF_WEEK:
                return formatDayOfWeek(value, timeFormat);
            default:
                return value;
        }
    };

    return { formatKpiValue };
};

export default useFormatKpiValue;
